var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLendoxLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 432 252"
    },
    xmlSpace: "preserve",
    viewBox: "94.08 99.74 238.93 47.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.93,113.3l0.93,0c0.95-0.01,1.87,0.09,2.75,0.29c0.04,0.01,0.09,0.02,0.13,0.03   c0.01,0,0.03,0.01,0.04,0.01c4.59,1.19,8.06,5.16,8.51,10c0.01,0.15,0.02,0.3,0.02,0.45l0.02,0c0.01,0.21,0.02,0.42,0.02,0.63   c0,6.32-5.12,11.44-11.44,11.44s-11.44-5.12-11.44-11.44c0-3.73,1.78-7.04,4.55-9.13h-12.7c-1.47,2.94-2.3,6.26-2.3,9.78   c0,12.1,9.81,21.9,21.9,21.9s21.9-9.81,21.9-21.9c0-2.02-0.27-3.97-0.78-5.82c-0.55-2.35-1.5-4.55-2.78-6.51   c-0.41-0.63-0.86-1.2-1.33-1.78c-3.91-4.8-9.92-7.88-16.65-7.95l0-0.02c0,0,0,0,0,0l-16.18-0.11c-4.02-0.53-7.15-3.85-8.51-3.38   c-0.62,0.21-0.5,3.86-0.5,3.86c0.08,4.92,2.87,8.99,6.48,9.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.9,136.14c-6.32,0-11.44-5.12-11.44-11.44c0-3.73,1.78-7.04,4.55-9.13H99.3c-1.47,2.94-2.3,6.26-2.3,9.78   c0,12.1,9.81,21.9,21.9,21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.98,103.33h7.33v43.48h-7.33V103.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.82,133.51h-24.55c0.88,4.57,4.69,7.5,10.14,7.5c3.52,0,6.27-1.11,8.5-3.4l3.93,4.51   c-2.81,3.34-7.21,5.1-12.6,5.1c-10.49,0-17.29-6.74-17.29-16.06c0-9.32,6.86-16,16.17-16c9.14,0,15.82,6.39,15.82,16.17   C197.93,131.92,197.88,132.8,197.82,133.51z M173.21,128.64h17.76c-0.59-4.51-4.04-7.62-8.85-7.62   C177.37,121.03,173.91,124.07,173.21,128.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.39,128.88v17.93h-7.32v-16.99c0-5.57-2.75-8.26-7.44-8.26c-5.22,0-8.73,3.16-8.73,9.43v15.82h-7.33   v-31.29h6.97v4.04c2.4-2.87,6.21-4.4,10.78-4.4C225.83,115.17,231.39,119.44,231.39,128.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.25,103.33v43.48h-7.03v-4.04c-2.46,2.99-6.09,4.45-10.37,4.45c-9.08,0-15.82-6.33-15.82-16.06   s6.74-16,15.82-16c4.04,0,7.62,1.35,10.08,4.22v-16.06H267.25z M260.05,131.16c0-5.98-4.04-9.79-9.32-9.79s-9.32,3.81-9.32,9.79   c0,5.98,4.04,9.79,9.32,9.79S260.05,137.14,260.05,131.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.89,131.16c0-9.38,7.03-16,16.64-16c9.73,0,16.7,6.62,16.7,16c0,9.38-6.97,16.06-16.7,16.06   C276.92,147.22,269.89,140.54,269.89,131.16z M295.85,131.16c0-5.98-3.98-9.79-9.32-9.79c-5.27,0-9.26,3.81-9.26,9.79   c0,5.98,3.98,9.79,9.26,9.79C291.86,140.95,295.85,137.14,295.85,131.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M324.74,146.81l-8.03-10.84l-8.09,10.84h-8.09l12.19-15.88l-11.66-15.41h8.15l7.68,10.25l7.68-10.25h7.91   l-11.72,15.29l12.25,16H324.74z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLendoxLogoWhite);
export default __webpack_public_path__ + "static/media/lendox_logo_white.081da681935d5825a1a9d68da2d4e69c.svg";
export { ForwardRef as ReactComponent };